<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null,
      originalEntry: null
    };
  },
  props: {
    entry: Object,
    totals: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(loadEntry) {
      this.originalEntry = loadEntry;
      this.editableEntry = _.cloneDeep(this.originalEntry);
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ADDRESS_EXTRA_DATA_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry.validations = response.data.accountContext.address.validations;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.pageLoading = true;
        Object.assign(this.originalEntry, this.editableEntry);
        this.pageLoading = false;
        this.$refs.baseEdit.closeDialog();
        this.$emit("entry-updated", this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_ADDRESS_EXTRA_DATA_QUERY = gql `
  {
    accountContext {
      address {
        validations
      }
    }
    globalContext {
      allStates {
        id
        name
        shortName
      }
    }
  }
`;
</script>

<style scoped></style>
